import { useState, useEffect, useContext } from "react";
import ContextStates from "../context/ContextStates";
import axios from "axios";
import Filtros from "./Filtros";
import { Url } from "./Url";
import { useNavigate } from 'react-router-dom';
import { FaPen, FaEye, FaEdit, FaTrash } from 'react-icons/fa';

const tiposPedidos = [
    {
        id: 0,
        descripcion: "Pedidos Nuevos"
    },
    {
        id: 1,
        descripcion: "Pedidos Entregados"
    },
    {
        id: 2,
        descripcion: "Pedidos No aceptados"
    },
];

const ListadoPedidos = () => {
    const [total, setTotal] = useState(0)
    const [totalComision, setTotalComision] = useState(0)
    const { 
        setFormView, 
        setViewOpen, 
        setPedidoSelected, 
        tipoPedido, 
        setTipoPedido, 
        zona, 
        fechaInicio, 
        fechaFin, 
        pedidos, 
        setPedidos, 
        setClienteSelected, 
        usuario, 
        modify, 
        setModify, 
        buscarCliente 
    } = useContext(ContextStates)
    const navigate = useNavigate();

    const editarCliente = (item) => {
        setClienteSelected(item);
        setFormView(31);
        setViewOpen(true);
    };

    useEffect(() => {
        const consultaPedidos = async () => {
            if (!zona?.id && !usuario?.id && !fechaInicio && !fechaFin) {
                setPedidos([]);
                return;
            }
            const formData = new FormData()
            formData.append("zona", zona?.id || 0)
            formData.append("fechaInicio", fechaInicio)
            formData.append("fechaFin", fechaFin)
            formData.append("tipoPedido", tipoPedido)
            formData.append("usuario", usuario?.id || 0)
            try {
                const response = await axios({
                    url: Url + 'api/listadoPedidos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("pedidos ", response)
                setPedidos(response.data.results || [])
            } catch (e) {
                console.log(e)
            }
        }
        consultaPedidos()
    }, [zona, fechaInicio, fechaFin, tipoPedido, usuario, modify, setPedidos])

    useEffect(() => {
        let auxTotal = 0;
        let auxComision = 0;
        if (pedidos) {
            pedidos.forEach(element => {
                // Omitir los pedidos con marker = 3 (no aceptados/reprogramados)
                if (Number(element.marker) === 3) return;
                if (element.total > 0) {
                    auxTotal = auxTotal + (element.total || 0);
                    auxComision = auxComision + (element.comision || 0);
                }
            });
            setTotal(auxTotal)
            setTotalComision(auxComision)
        }
    }, [pedidos])

    const handlePedido = (item) => {
        setPedidoSelected(item)
        setFormView(210);
        setViewOpen(true)
    }

    const setPedido = (item) => {
        setClienteSelected(item)
        navigate("/nuevopedido", { replace: true });
    }

    const handleDeletePedido = async (item) => {
        if (window.confirm(`¿Estás seguro de que deseas eliminar permanentemente el pedido del cliente "${item.cliente}"?`)) {
            const formData = new FormData();
            formData.append("id", item.idpedido);
            try {
                const response = await axios({
                    url: Url + 'api/delPedido.php',
                    method: 'POST',
                    data: formData,
                });
                
                if (response.data.results && response.data.results.success) {
                    // Refrescar el listado incrementando el contador 'modify'
                    setModify(m => m + 1);
                } else {
                    const errMsg = response.data.results?.error || "Error desconocido";
                    alert("Error al eliminar el pedido: " + errMsg);
                }
            } catch (e) {
                console.log(e);
                alert("No se pudo conectar con el servidor para eliminar el pedido");
            }
        }
    }

    // Filtrar pedidos excluyendo marker = 3 y aplicando la búsqueda de cliente
    const pedidosFiltrados = (pedidos || []).filter(item => {
        if (Number(item.marker) === 3) return false;
        return buscarCliente
            ? item.cliente?.toLowerCase().includes(buscarCliente.toLowerCase())
            : true;
    });

    return (
        <div className="mt-4 mb-12 w-full z-0 animate-fadeIn">
            {/* Filtros Container */}
            <div className='bg-white/80 backdrop-blur-md border border-slate-200/80 shadow-sm rounded-2xl p-6 mb-6 transition-all'>
                <Filtros />
                
                {/* Segmented Control / Modern Filter Pills */}
                <div className="flex flex-wrap gap-2 bg-slate-100/80 p-1.5 rounded-xl max-w-xl mt-6">
                    {tiposPedidos.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            onClick={() => setTipoPedido(item.id)}
                            className={`flex-1 min-w-[120px] transition-all px-4 py-2.5 rounded-lg font-semibold text-xs uppercase tracking-wider text-center ${
                                tipoPedido === item.id
                                    ? 'bg-white text-slate-800 shadow-sm ring-1 ring-black/5'
                                    : 'text-slate-500 hover:text-slate-800 hover:bg-white/40'
                            }`}
                        >
                            {item.descripcion}
                        </button>
                    ))}
                </div>
            </div>

            {/* Pedidos List / Table */}
            {pedidosFiltrados.length > 0 ? (
                <div className="space-y-6">
                    {/* Desktop View (Table) */}
                    <div className='hidden md:block w-full overflow-hidden border border-slate-200/60 shadow-sm rounded-2xl bg-white'>
                        <div className="overflow-x-auto">
                            <table className='w-full text-sm text-left border-collapse'>
                                <thead>
                                    <tr className='bg-slate-50/75 border-b border-slate-200/80 text-slate-500 font-semibold text-xs tracking-wider uppercase text-center'>
                                        <th className="py-4 px-3 font-semibold text-center w-12">#</th>
                                        <th className="py-4 px-4 font-semibold text-center">Cliente</th>
                                        <th className="py-4 px-4 font-semibold text-center">Domicilio</th>
                                        <th className="py-4 px-4 font-semibold text-center">Teléfono</th>
                                        <th className="py-4 px-4 font-semibold text-center w-28">Fecha / Hora</th>
                                        <th className="py-4 px-4 font-semibold text-center w-28">Total</th>
                                        <th className="py-4 px-4 font-semibold text-center w-28">Comisión</th>
                                        <th className='py-4 px-4 font-semibold text-center print:hidden w-72'>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        pedidosFiltrados.map((item, index) => {
                                            if (item.total <= 0 && item.estado !== 7 && item.estado !== 2) return null;

                                            // Determine row status classes
                                            let statusClasses = "bg-white hover:bg-slate-50/80";
                                            if (item.estado === 7 || item.estado === 2) {
                                                statusClasses = "bg-rose-50/40 hover:bg-rose-100/30 text-rose-950";
                                            } else if (item.saldo && item.saldo > 0 && item.saldo === item.total) {
                                                statusClasses = "bg-rose-50/60 hover:bg-rose-100/50 text-rose-950";
                                            } else if (item.saldo && item.saldo > 0 && item.saldo < item.total) {
                                                statusClasses = "bg-amber-50/60 hover:bg-amber-100/50 text-amber-950";
                                            } else if (index % 2 !== 0) {
                                                statusClasses = "bg-slate-50/40 hover:bg-slate-50/80";
                                            }

                                            return (
                                                <tr 
                                                    key={index} 
                                                    className={`transition-all border-b border-slate-100 text-center ${statusClasses}`}
                                                >
                                                    <td className="py-3.5 px-3 text-slate-400 font-medium">{index + 1}</td>
                                                    <td className="py-3.5 px-4 font-semibold text-slate-800">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <span>{item.cliente}</span>
                                                            <button
                                                                type="button"
                                                                className='p-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 hover:text-slate-800 transition-all shadow-sm'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    editarCliente(item);
                                                                }}
                                                                title="Editar Cliente"
                                                            >
                                                                <FaPen size={10} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3.5 px-4 text-slate-600">{item.domicilio}</td>
                                                    <td className="py-3.5 px-4 text-slate-600">
                                                        {item.telefono ? (
                                                            <a href={`tel:${item.telefono}`} className="text-indigo-600 hover:underline font-medium">
                                                                {item.telefono}
                                                            </a>
                                                        ) : '-'}
                                                    </td>
                                                    <td className="py-3.5 px-4 text-slate-500 text-xs">
                                                        <div className="font-medium">{item.fechapedido}</div>
                                                        <div className="text-[10px] text-slate-400">{item.horapedido}</div>
                                                    </td>
                                                    <td className="py-3.5 px-4 font-bold text-slate-900">$ {item.total.toLocaleString("es-AR", { maximumFractionDigits: 2, })}</td>
                                                    <td className="py-3.5 px-4 text-emerald-600 font-semibold">
                                                        {item.comision > 0 ? `$ ${item.comision.toLocaleString("es-AR", { maximumFractionDigits: 2, })}` : '-'}
                                                    </td>
                                                    <td className="py-3.5 px-4 print:hidden">
                                                        <div className="flex justify-center items-center gap-2">
                                                            <button
                                                                type="button"
                                                                className="flex items-center justify-center gap-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full"
                                                                onClick={() => handlePedido(item)}
                                                                title="Ver Pedido"
                                                            >
                                                                <FaEye size={13} />
                                                                <span>Ver</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="flex items-center justify-center gap-1.5 bg-amber-50 hover:bg-amber-100 text-amber-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full"
                                                                onClick={() => setPedido(item)}
                                                                title="Editar Pedido"
                                                            >
                                                                <FaEdit size={13} />
                                                                <span>Editar</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="flex items-center justify-center gap-1.5 bg-rose-50 hover:bg-rose-100 text-rose-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full"
                                                                onClick={() => handleDeletePedido(item)}
                                                                title="Eliminar Pedido"
                                                            >
                                                                <FaTrash size={13} />
                                                                <span>Eliminar</span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    <tr className="bg-slate-50/75 border-t-2 border-double border-slate-200/80 text-center font-bold uppercase text-slate-800">
                                        <td colSpan={5} className="py-5 px-4 text-right pr-6 font-extrabold tracking-wider text-xs text-slate-500">Total General</td>
                                        <td className="py-5 px-4 font-black text-slate-900 text-base">$ {total.toLocaleString("es-AR", { maximumFractionDigits: 2, })}</td>
                                        <td className="py-5 px-4 text-emerald-600 text-base">$ {totalComision.toLocaleString("es-AR", { maximumFractionDigits: 2, })}</td>
                                        <td className="py-5 px-4 print:hidden"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Mobile View (Cards) */}
                    <div className="block md:hidden space-y-4">
                        {
                            pedidosFiltrados.map((item, index) => {
                                if (item.total <= 0 && item.estado !== 7 && item.estado !== 2) return null;

                                // Determinar color de fondo, borde y texto de estado según el marker / estado
                                let statusBorderColor = "border-l-4 border-l-slate-300";
                                let statusBg = "bg-white";
                                let badgeColor = "bg-slate-100 text-slate-700";
                                let badgeText = "Sin Estado";

                                if (item.estado === 0) {
                                    statusBorderColor = "border-l-4 border-l-sky-500";
                                    badgeColor = "bg-sky-50 text-sky-700 border border-sky-200";
                                    badgeText = "Pendiente";
                                } else if (item.estado === 1) {
                                    statusBorderColor = "border-l-4 border-l-emerald-500";
                                    badgeColor = "bg-emerald-50 text-emerald-700 border border-emerald-200";
                                    badgeText = "En Ruta";
                                } else if (item.estado === 7 || item.estado === 2) {
                                    statusBorderColor = "border-l-4 border-l-rose-500";
                                    statusBg = "bg-rose-50/20";
                                    badgeColor = "bg-rose-50 text-rose-700 border border-rose-200";
                                    badgeText = "No aceptado";
                                }

                                // Ajuste por Saldos
                                if (item.saldo && item.saldo > 0) {
                                    if (item.saldo === item.total) {
                                        statusBg = "bg-rose-50/30";
                                        statusBorderColor = "border-l-4 border-l-rose-500";
                                    } else {
                                        statusBg = "bg-amber-50/30";
                                        statusBorderColor = "border-l-4 border-l-amber-500";
                                    }
                                }

                                return (
                                    <div 
                                        key={index} 
                                        className={`p-4 rounded-2xl border border-slate-200/80 shadow-sm ${statusBg} ${statusBorderColor} transition-all active:scale-[0.995]`}
                                    >
                                        {/* Cabecera de Tarjeta */}
                                        <div className="flex items-start justify-between gap-2 mb-2.5">
                                            <div className="flex items-center gap-2">
                                                <span className="text-[10px] font-bold text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">
                                                    #{index + 1}
                                                </span>
                                                <h3 className="font-bold text-slate-800 text-sm leading-snug">
                                                    {item.cliente}
                                                </h3>
                                            </div>
                                            <button
                                                type="button"
                                                className='p-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 active:scale-95 transition-all shadow-sm flex items-center justify-center'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    editarCliente(item);
                                                }}
                                                title="Editar Cliente"
                                            >
                                                <FaPen size={11} />
                                            </button>
                                        </div>

                                        {/* Estado Badges */}
                                        <div className="flex flex-wrap gap-1.5 mb-3">
                                            <span className={`text-[9px] uppercase font-extrabold tracking-wider px-2 py-0.5 rounded-md ${badgeColor}`}>
                                                {badgeText}
                                            </span>
                                            {item.motivo && (
                                                <span className="text-[9px] uppercase font-extrabold tracking-wider px-2 py-0.5 rounded-md bg-amber-50 text-amber-700 border border-amber-200">
                                                    Rechazo: {item.motivo}
                                                </span>
                                            )}
                                        </div>

                                        {/* Información del pedido */}
                                        <div className="space-y-1.5 mb-3 text-slate-600 text-xs">
                                            {item.domicilio && (
                                                <div className="flex items-center gap-2">
                                                    <span className="text-slate-400">📍</span>
                                                    <span className="font-medium text-slate-700 line-clamp-1">{item.domicilio}</span>
                                                </div>
                                            )}
                                            {item.telefono && (
                                                <div className="flex items-center gap-2">
                                                    <span className="text-slate-400">📞</span>
                                                    <a 
                                                        href={`tel:${item.telefono}`}
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="text-indigo-600 hover:underline font-semibold"
                                                    >
                                                        {item.telefono}
                                                    </a>
                                                </div>
                                            )}
                                            {(item.fechapedido || item.horapedido) && (
                                                <div className="flex items-center gap-2">
                                                    <span className="text-slate-400">📅</span>
                                                    <span className="text-slate-500 font-medium">
                                                        {item.fechapedido} {item.horapedido && ` a las ${item.horapedido}`}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Totales Card */}
                                        <div className="grid grid-cols-2 gap-2 bg-slate-50 p-2.5 rounded-xl border border-slate-100 mb-3">
                                            <div>
                                                <span className="block text-[9px] text-slate-400 font-bold uppercase tracking-wider">Total</span>
                                                <span className="text-sm font-extrabold text-slate-900">
                                                    $ {item.total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                                </span>
                                            </div>
                                            <div>
                                                <span className="block text-[9px] text-slate-400 font-bold uppercase tracking-wider">Comisión</span>
                                                <span className="text-sm font-bold text-emerald-600">
                                                    {item.comision > 0 ? `$ ${item.comision.toLocaleString("es-AR", { maximumFractionDigits: 2 })}` : '-'}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Acciones */}
                                        <div className="grid grid-cols-3 gap-2">
                                            <button
                                                type="button"
                                                className="flex items-center justify-center gap-1 bg-indigo-50 hover:bg-indigo-100 active:bg-indigo-200 text-indigo-600 font-bold py-2 rounded-xl text-xs transition-all shadow-sm"
                                                onClick={() => handlePedido(item)}
                                            >
                                                <FaEye size={12} />
                                                <span>Ver</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="flex items-center justify-center gap-1 bg-amber-50 hover:bg-amber-100 active:bg-amber-200 text-amber-600 font-bold py-2 rounded-xl text-xs transition-all shadow-sm"
                                                onClick={() => setPedido(item)}
                                            >
                                                <FaEdit size={12} />
                                                <span>Editar</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="flex items-center justify-center gap-1 bg-rose-50 hover:bg-rose-100 active:bg-rose-200 text-rose-600 font-bold py-2 rounded-xl text-xs transition-all shadow-sm"
                                                onClick={() => handleDeletePedido(item)}
                                            >
                                                <FaTrash size={12} />
                                                <span>Eliminar</span>
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        }

                        {/* Tarjeta de Resumen de Totales para Móvil */}
                        <div className="bg-gradient-to-br from-slate-800 to-slate-900 text-white rounded-2xl p-4 shadow-md border border-slate-700/50 space-y-2.5">
                            <h4 className="text-[10px] uppercase font-extrabold tracking-widest text-slate-400">Resumen de Totales</h4>
                            <div className="flex justify-between items-center border-b border-slate-700/50 pb-2">
                                <span className="text-xs font-semibold text-slate-300">Total General</span>
                                <span className="text-base font-black text-white">
                                    $ {total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                </span>
                            </div>
                            <div className="flex justify-between items-center">
                                <span className="text-xs font-semibold text-slate-300">Total Comisión</span>
                                <span className="text-base font-black text-emerald-400">
                                    $ {totalComision.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="bg-slate-50 border border-dashed border-slate-200 rounded-2xl p-10 text-center text-slate-500 font-medium">
                    No se encontraron pedidos.
                </div>
            )}
        </div>
    )
}

export default ListadoPedidos;
